import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faUpload, faImages, faHardDrive } from "@fortawesome/free-solid-svg-icons";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { bytesToSize } from '../utils/bytesSize';

const STAT_META = [
  { key: "total_images", icon: faImages,    color: "#6366f1", bg: "#eef2ff", labelKey: "event_photos_stats.photos"      },
  { key: "used_memory",  icon: faHardDrive, color: "#f59e0b", bg: "#fffbeb", labelKey: "event_photos_stats.memory_used" },
];

const EventPhotosStats = ({ id_name, storage }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!storage) return null;

  const statValues = {
    total_images: storage?.total_images ?? 0,
    used_memory:  storage?.used_memory ? bytesToSize(storage.used_memory) : "0",
  };

  const actionBtn = (onClick, icon, label, color) => (
    <button
      onClick={onClick}
      style={{
        display: "flex", alignItems: "center", gap: "6px",
        height: 32, padding: "0 12px",
        borderRadius: "8px", border: "1px solid #e5e7eb",
        background: "#fff", color, cursor: "pointer",
        fontSize: "12px", fontWeight: 600,
        transition: "all 0.15s",
      }}
      onMouseEnter={e => { e.currentTarget.style.background = "#f3f4f6"; }}
      onMouseLeave={e => { e.currentTarget.style.background = "#fff"; }}
    >
      <FontAwesomeIcon icon={icon} style={{ fontSize: "12px" }} />
      {label}
    </button>
  );

  return (
    <Card
      className="mt-3"
      style={{ border: "none", borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)", overflow: "hidden" }}
    >
      <Card.Body style={{ padding: "20px 24px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" }}>
          <div style={{ fontSize: "11px", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em" }}>
            {t("event_photos_stats.storage")}
          </div>
          {id_name && (
            <div style={{ display: "flex", gap: "6px" }}>
              {actionBtn(() => navigate(`/admin/${id_name}`), faGear, t("event_photos_stats.edit_gallery"), "#6b7280")}
              {actionBtn(() => navigate(`/admin/upload/${id_name}`), faUpload, t("event_photos_stats.upload"), "#10b981")}
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          {STAT_META.map(({ key, icon, color, bg, labelKey }) => (
            <div
              key={key}
              style={{ flex: 1, background: "#fafafa", border: "1px solid #f0f0f0", borderRadius: "12px", padding: "14px 16px" }}
            >
              <div style={{ width: 32, height: 32, borderRadius: "8px", background: bg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
                <FontAwesomeIcon icon={icon} style={{ color, fontSize: "14px" }} />
              </div>
              <div style={{ fontSize: "22px", fontWeight: 700, color: "#111827", lineHeight: 1 }}>
                {statValues[key]}
              </div>
              <div style={{ fontSize: "11px", color: "#9ca3af", marginTop: "5px", fontWeight: 500 }}>
                {t(labelKey)}
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default EventPhotosStats;
